import React, { FC, useCallback } from 'react'

import { IChangeTreeSelectFn, TreeSelect } from 'cng-common/components/treeSelect'

import { IGeoMappingProps } from './models/geoMappingProps'
import { IMappedGeoMappingItem } from './models/mappedGeoMappingItem'

export interface IGeoMappingWithOptionsProps extends Omit<IGeoMappingProps, 'allowedCountryCodes'> {
  options: IMappedGeoMappingItem[]
}

export const GeoMappingWithOptions: FC<IGeoMappingWithOptionsProps> = ({
  options,
  values = [],
  label,
  className,
  popupClassName,
  onSelectChange,
  typeOfSelectedNodes,
  disabled = false,
  itemCaption,
}) => {
  /** -------------------- Methods ----------------------- */
  const handleChange = useCallback<IChangeTreeSelectFn<IMappedGeoMappingItem>>(
    (displayedItems, allSelectedItems, onlyLeaves) => {
      const mapById = (item: IMappedGeoMappingItem) => item.itemId
      onSelectChange(
        displayedItems.map(mapById),
        allSelectedItems.map(mapById),
        onlyLeaves.map(mapById)
      )
    },
    [onSelectChange]
  )

  const handleSearch = useCallback((item: IMappedGeoMappingItem, searchValue: string) => {
    const fieldsToSearch = [item.itemId, item.name]
    return fieldsToSearch.some((value) => value.toLowerCase().includes(searchValue.toLowerCase()))
  }, [])

  return (
    <div className={className}>
      <TreeSelect
        disabled={disabled}
        values={values}
        label={label}
        popupClassName={popupClassName}
        data={options}
        itemCaption={itemCaption || 'name'}
        onChange={handleChange}
        onSearch={handleSearch}
        typeOfSelectedNodes={typeOfSelectedNodes}
      />
    </div>
  )
}
